module.exports = __webpack_public_path__ + "8e8940f8ce58a4fe64a144e61c5d443f.pdf";